// import TodayAttendanceService from "../service/TodayService";
// import axios from "axios";

// export const fetchTodayAttendance = (date, company, location1) => async dispatch => {
//   dispatch({ type: "FETCH_ATTENDANCE_REQUEST" });
//   try {    
//     const response = await TodayAttendanceService.get(
//       `attme/GetAttendance?date=${date}&company=${company}&location=${location1}`,
//       {
//         headers: {
//           UserId: "DTSUSER",
//           Password: "Dts@10099",
//         },
//       }
//     );
//     dispatch({ type: "FETCH_ATTENDANCE_SUCCESS", payload: response.data.AttendancList });
//   } catch (error) {
//     console.error("Error fetching attendance data:", error);
//     dispatch({ type: "FETCH_ATTENDANCE_FAILURE" });
//   }
// };





import TodayAttendanceService from "../service/TodayService";

export const fetchTodayAttendance = (date, company, location1) => async dispatch => {
  dispatch({ type: "FETCH_ATTENDANCE_REQUEST" });

  try {
    const response = await TodayAttendanceService.getAttendance(date, company, location1);

    dispatch({
      type: "FETCH_ATTENDANCE_SUCCESS",
      payload: response.data.AttendancList,
    });

  } catch (error) {
    console.error("Error fetching attendance:", error);
    dispatch({ type: "FETCH_ATTENDANCE_FAILURE" });
  }
};

